import React from "react";
import { Row, Button, Modal } from "react-bootstrap";

import * as Constants from "../../../../constants/Constants";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";

const DVNAuditModal = ({ onModalClose, onApprove, show, approvalErrorMsg }) => {
  return (
    <Modal show={show} onHide={() => onModalClose()} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title className="text-center text-uppercase w-100">
          {Constants.BUTTON_AUDIT_COMPLETE}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {approvalErrorMsg && (
          <div className="d-flex justify-content-between">
            <ErrorContainer
              errorMsg={approvalErrorMsg}
              errorStatus={true}
              errorStyle="errorMessage"
            />
          </div>
        )}
        <Row>
          <p style={{ fontSize: "14px", fontWeight: "bold" }}>
            {Constants.AUDIT_COMPLETE_MODAL_BODY_TEXT}
          </p>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="button-later-md" onClick={() => onModalClose()}>
          {Constants.BUTTON_CANCEL}
        </Button>
        <Button className="button-primary-md" onClick={() => onApprove()}>
          {Constants.BUTTON_APPROVE}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default DVNAuditModal;
